<template>
  <main>
    <PageIntro v-if="appLogin === false"
      :heading="'Register for a <span>My Stoke</span> account'"
      :body="'<p>Enter your details below to create your MyStoke account. One time registration is required with your email and postal address that will then allow you to purchase tickets online.</p>'" />
    <PageIntro v-else
      :heading="'Register for a <span>My Stoke</span> account'"
      :body="''" />
    <RegistrationFull />
    <FooterShout v-if="appLogin === false" :type="'signin'"/>
  </main>
</template>

<script>
  import RegistrationFull from '@/components/RegistrationFull'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      RegistrationFull,
      PageIntro,
      FooterShout
    },
    data() {
      return {
        appLogin: false
      }
    },
    mounted () {
      // if they are coming from the app specific login URL adapt the page accordingly
      if(this.$router.currentRoute.name === 'app-register'){
        this.appLogin = true
      }
    },
  }
</script>
